import { primaryColor } from './status/primary';
export const primary = (mode)=>{
    const color = primaryColor(mode);
    return {
        ...color,
        // Use the high/low contrast versions instead. This is meant to backfill the MUI tokens.
        light: mode === 'light' ? color.lowContrast : color.highContrast,
        dark: mode === 'light' ? color.highContrast : color.lowContrast
    };
};

//# sourceMappingURL=primary.js.map